import { Endpoint, URL_PARTS } from '../base/endpoints';
import formatArguments from './formatArguments.util';

type BuildRequestUrlProps = {
  endpoint: Endpoint;
  id: string;
  urlParams?: Record<string, string | number | boolean | string[]>;
};

export default function buildRequestUrl({ endpoint, id, urlParams = {} }: BuildRequestUrlProps): string {
  const { buildPath, defaultArgs = {} } = URL_PARTS[endpoint];
  let url = buildPath(id);

  const mergedParams = {
    ...defaultArgs,
    ...urlParams,
  };

  Object.entries(mergedParams).forEach(([key, value]) => {
    const pathParam = `{${key}}`;
    if (url.includes(pathParam)) {
      url = url.replace(pathParam, String(value));
      delete mergedParams[key];
    }
  });

  const remainingParams = Object.fromEntries(
    Object.entries(mergedParams).filter(([_, value]) => value !== undefined)
  );

  if (Object.keys(remainingParams).length > 0) {
    url += formatArguments(remainingParams);
  }

  return url;
}